<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconMeetings_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M5.974 12.737h4.052l.535 1.604a.46.46 0 0 1-.437.606H5.876a.46.46 0 0 1-.437-.606zM2.916 1.684h10.168C14.142 1.684 15 2.542 15 3.6v6.484A1.916 1.916 0 0 1 13.084 12H2.916A1.916 1.916 0 0 1 1 10.084V3.6c0-1.058.858-1.916 1.916-1.916m10.168 9.21a.81.81 0 0 0 .81-.81V3.6a.81.81 0 0 0-.81-.81H2.916a.81.81 0 0 0-.81.81v6.484c0 .448.363.81.81.81zM4.1 3.785a1 1 0 0 0-1 1v.8a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-.8a1 1 0 0 0-1-1zm3.2 1a1 1 0 0 1 1-1h3.6a1 1 0 0 1 1 1v4.3a1 1 0 0 1-1 1H8.3a1 1 0 0 1-1-1zm-3.2 2.5a1 1 0 0 0-1 1v.8a1 1 0 0 0 1 1h1.5a1 1 0 0 0 1-1v-.8a1 1 0 0 0-1-1z"
        clip-rule="evenodd"
    />
</svg>
